import { currentFeatures, endpoints } from "../../../configs/Settings";
import { useAxios } from "../../../utils/useAxios";
import { HTTPResponseStatus } from "../../../utils/enum";
import { toast } from "react-toastify";
import { getAuthToken } from "@/services/auth/OAuthApplication";

interface IProps {
  id?: string;
  identifier?: string;
  includePatient?: boolean;
  patient?: string;
  active?: boolean;
  vetRelated?: boolean; // Se true, adiciona header X-Target-System: vet
  includePhoto?: boolean;
  authType?: string;
}

export async function GetRelatedPerson({
  id,
  identifier,
  includePatient,
  patient,
  active,
  vetRelated,
  includePhoto,
  authType,
}: IProps) {
  let url = `${endpoints.ADMFHIR}/RelatedPerson`;
  let hasParams = false;

  if (id) {
    url = `${url}?_id=${id}`;
    hasParams = true;
  }
  if (identifier) {
    url = `${url}${hasParams ? "&" : "?"}identifier=${identifier}`;
    hasParams = true;
  }
  if (patient) {
    url = `${url}${hasParams ? "&" : "?"}patient=${patient}`;
    hasParams = true;
  }
  if (includePatient) {
    url = `${url}${hasParams ? "&" : "?"}_include=RelatedPerson:patient`;
    hasParams = true;
  }
  if (active) {
    url = `${url}${hasParams ? "&" : "?"}active=${active}`;
    hasParams = true;
  }
  if (includePhoto && !currentFeatures?.defaultApp) {
    url = `${url}${hasParams ? "&" : "?"}include_photo_data=${includePhoto}`;
    hasParams = true;
  }
  if (!currentFeatures?.defaultApp) {
    url = `${url}${hasParams ? "&" : "?"}patient:Patient.active=true`;
    hasParams = true;
  }

  // Headers base
  const headers: any = {
    Authorization: await getAuthToken(),
    "Content-Type": "application/fhir+json",
    Accept: "application/fhir+json",
  };

  const response = await useAxios
    .get(url, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`GetRelatedPerson: ${response.status}`);
      }
      return { status: HTTPResponseStatus.Success, data: response.data };
    })
    .catch((error) => {
      console.error("GetRelatedPerson ", error);
      // toast.error(`GetRelatedPerson Error: ${error?.response?.status}`);
      // throw new Error();
    });
  if (response) return response;
}
